import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import debug_45headers_45global from "/app/middleware/debug-headers.global.ts";
import posthog_45global from "/app/middleware/posthog.global.ts";
import webview_45navigation_45global from "/app/middleware/webview-navigation.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  debug_45headers_45global,
  posthog_45global,
  webview_45navigation_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-mobile": () => import("/app/middleware/isMobile.ts"),
  "react-native-headers": () => import("/app/middleware/react-native-headers.ts")
}